export const ID_OTHER_REASON = '101';
